<template>
  <div style="padding-top: 20px;padding-left: 20px;background-color: white;">
    <el-button type="primary" style="width: 110px" no="uploadFile" @click="$refs.dropUploader.triggeFileSelectWindow()">{{ $t('SeaExport.UploadFile') }}</el-button>
    <drop-uploader
      ref="dropUploader"
      :action="URL.sys.ocrImportAndAnalyseFile"
      :upload-params="{ ocrTemplateUuid: ocrTemplate.uuid }"
      :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
      :file-format="fileFormat"
      :close-on-click-modal="false"
      :multiple="false"
      @upload-result="uploadSuccessHandler"
    />
    <cargo-left-right-resize
      style="width:100%;height: 100%;"
      :left-style="{'min-width': '550px',width:'33%',}"
      :right-style="{'min-width': '110px',width:'66%'}"
    >
      <template slot="left">
        <el-form>
          <el-form-item :label="$t('CargoMsg.Cargo_OcrCode')">
            <el-button type="primary" :disabled="!ocrTemplate.code" @click="runCode">{{ $t('CargoMsg.Cargo_Run') }}</el-button>
            <el-tooltip :content="$t('Message.CodeTip')" placement="right">
              <i class="el-icon-warning" style="color: #E6A23C;padding: 0 5px;font-size: 18px;margin-left: 10px" />
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-input v-model="ocrTemplate.code" :filter-chars="false" no="1" type="textarea" :rows="37" style="width: 100%;height:670px;margin-top: 5px;" />
          </el-form-item>
        </el-form>
      </template>
      <template slot="right">
        <cargo-left-right-resize
          style="width:100%;height: 100%;"
          :left-style="{'min-width': '550px',width:'50%',}"
          :right-style="{'min-width': '550px',width:'50%'}"
        >
          <template slot="left">
            <el-form label-position="top">
              <el-form-item :label="$t('CargoMsg.Cargo_originalValue')">
                <div style="height:669px;border: 1px solid #cccccc">
                  <json-viewer
                    v-if="ocrTemplate.originResultJson"
                    :value="JSON.parse(ocrTemplate.originResultJson)"
                    sort
                    :expand-depth="6"
                    style="white-space: nowrap;font-size: small;height:667px;font-family: 'Courier New';vertical-align: top;overflow-y: auto;"
                  />
                </div>
              </el-form-item>
            </el-form>
          </template>
          <template slot="right">
            <el-form label-position="top">
              <el-form-item :label="$t('CargoMsg.Cargo_DebuggingResults')">
                <div style="height:669px;border: 1px solid #cccccc">
                  <json-viewer
                    v-if="ocrTemplate.resultJson"
                    :value="JSON.parse(ocrTemplate.resultJson)"
                    sort
                    :expand-depth="6"
                    style="white-space: nowrap;font-size: small;height:667px;font-family: 'Courier New';vertical-align: top;overflow-y: auto;"
                  />
                </div>
              </el-form-item>
            </el-form>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-left-right-resize>
    <div slot="footer" style="display: flex;justify-content: center">
      <el-button type="primary" no="4" @click="saveOcrTemplate">{{ $t('common.btn.save') }}</el-button>
      <el-button type="primary" no="5" style="margin-left: 5px;" @click="goBack()"> {{ $t('CargoMsg.Cargo_Back') }} </el-button>
    </div>
  </div>
</template>

<script>
import JsonViewer from 'vue-json-viewer'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreviewCwmi from '@/views/cargo/v0/ToolAssistant/ocr/components/ImagePreviewCwmi'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { saveOcrTemplate } from '@/api/ocrTemplate'
import URL from '@/api/urlTranslator'

export default {
  name: 'OcrCodeHandle',
  components: { ImagePreviewCwmi, CargoLeftRightResize, DropUploader, JsonViewer },
  props: {
    ocrTemplate: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      URL,
      curFocus: '',
      fileFormat: '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif',
      pageNum: 1 // 当前页
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    }
  },
  methods: {
    handleClose() {
      console.log('result close')
      this.$emit('close')
    },
    goBack() {
      this.$emit('goBack')
    },
    // 最终保存
    saveOcrTemplate() {
      this.loading = getLoading4Cxt()
      saveOcrTemplate(this.ocrTemplate).then(res => {
        this.action = 'look'
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).finally(() => {
        this.loading.close()
      })
    },
    getFileExtension(fileName) {
      if (!fileName) {
        return ''
      }
      const dotIndex = fileName.lastIndexOf('.')
      if (dotIndex >= 0) {
        return fileName.substring(dotIndex)
      } else {
        return '' // 没有后缀名
      }
    },
    uploadSuccessHandler(res) {
      this.fileType = this.getFileExtension(res.fileName)
      this.ocrTemplate.originResultJson = res.originResultJson
    },
    // 执行二次代码
    runCode() {
      this.loading = getLoading4Cxt()
      try {
        if (!this.ocrTemplate.originResultJson) {
          this.$message.warning(this.$t('Message.PleaseUpload'))
          return
        }
        try {
          var codeFun = new Function('params', 'fileType', 'const result = JSON.parse(params);' + this.ocrTemplate.code + ';return JSON.stringify(result);')
          this.ocrTemplate.resultJson = codeFun(this.ocrTemplate.originResultJson, this.fileType ? this.fileType : this.getFileExtension(this.ocrTemplate.fileName))
          this.$message.success(this.$t('Message.RunSuccess'))
          return
        } catch (e) {
          console.log('runCode error', e)
          this.$message.error(this.$t('Message.RunFail'))
          return
        }
      } finally {
        this.loading.close()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
